/**
 * Created by Andrey Popov on 5/12/23.
 */

const WebWorker = {
    IsAvailable: function () {
        return ["blocks"].indexOf(cleverapps.config.type) !== -1;
    },

    Build: function () {
        let webWorker;

        const inlinedWorker = document.getElementById("web-worker-task");
        if (cleverapps.isLocalhost() && !inlinedWorker) {
            webWorker = new Worker("features/src/type_blocks/worker/blocksworker.js");
        } else {
            const workerTaskScript = inlinedWorker.innerHTML;
            webWorker = new Worker(window.URL.createObjectURL(new Blob([workerTaskScript], { type: "text/javascript" })));
        }

        const wrongForms = Forms.ALL_POSSIBLE_VARIANTS.filter((form) => !Array.isArray(form));
        if (wrongForms.length) {
            cleverapps.throwAsync(`Wrong forms: ${JSON.stringify(wrongForms)}`);
        }

        webWorker.postMessage({ forms: Forms.ALL_POSSIBLE_VARIANTS });
        return webWorker;
    }
};
